@import '~style-sheet-helpers/core.less';
@import '../../app-brand/entities/entity-layer.module.less';

.fulfillment-plan-activity-list {
  width: 100%;
  margin-right: 10px;
  justify-content: flex-end;
  align-items: left;
  min-height: 35px;
}

.fulfillment-plan-activity-entry {
  color: @fulfillment-plans--default--text-color;
  font-size: 13px;
  padding: 0 10px;
  line-height: 18px;
  word-break: break-word;
  white-space: pre-line;
}

.fulfillment-plan-activity-entry-title {
  color: @fulfillment-plans--default--text-color;
  font-size: 13px;
  padding: 5px 10px 5px 0;
  line-height: 13px;
  white-space: pre-line;
}

.icon-part {
  height: 14px;
  width: 14px;
}

.icon-part-scale {
  height: 11px;
  width: 11px;
}

.button-load-all {
  padding: 0 10px;
}

.loading-icon {
  height: 50px;
  width: 50px;
  margin: auto;
}
